import {
  SELECT_QUESTION,
  SET_ALL_QUESTIONS,
  SET_INFINITE_QUESTIONS,
} from "../types/questionsTypes";

const initialState = {
  all: [],
  selected: null,
  totalPages: 0,
};

const questionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_QUESTIONS:
      return {
        ...state,
        all: action.payload.items,
        totalPages: action.payload.totalPages,
      };
    case SET_INFINITE_QUESTIONS:
      return {
        ...state,
        all: [...state.all, ...action.payload.items],
        totalPages: action.payload.totalPages,
      };
    case SELECT_QUESTION:
      return { ...state, selected: action.payload };
    default:
      return state;
  }
};

export default questionsReducer;
